import React from 'react';
import './SuccessPopup.css';

const SuccessPopup = ({ isOpen, onClose, message, title = "Success!" }) => {
    if (!isOpen) return null;

    return (
        <div className="success-overlay" onClick={onClose}>
            <div className="success-popup" onClick={(e) => e.stopPropagation()}>
                <div className="success-icon-container">
                    <i className="ri-checkbox-circle-fill success-icon-large"></i>
                </div>

                <div className="success-content">
                    <h2>{title}</h2>
                    <p>{message}</p>
                </div>

                <button onClick={onClose} className="success-button">
                    Got it!
                </button>
            </div>
        </div>
    );
};

export default SuccessPopup;
